import { render, staticRenderFns } from "./BottomContainer.vue?vue&type=template&id=1ae47df4&scoped=true&"
import script from "./BottomContainer.vue?vue&type=script&lang=ts&"
export * from "./BottomContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BottomContainer.vue?vue&type=style&index=0&id=1ae47df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae47df4",
  null
  
)

export default component.exports